/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  throwError: function throwError(message) {
    throw new Error(message);
  },
  getExperiment: function getExperiment(experimentSummaries, experimentName) {
    return experimentSummaries.experimentAdds.find(function (item) {
      return item.name === experimentName;
    });
  },
  getGoal: function getGoal(experimentSummaries, goalName) {
    return experimentSummaries.goalAdds[goalName];
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  EXPERIMENT_SUMMARIES_FETCHED: 'EXPERIMENT_SUMMARIES_FETCHED',
  CLIENT_INITIALISED: 'CLIENT_INITIALISED',
  VARIANT_CALCULATED: 'VARIANT_CALCULATED',
  EXPERIMENT_NOT_FOUND: 'EXPERIMENT_NOT_FOUND',
  EXPERIMENT_TRACKED: 'EXPERIMENT_TRACKED',
  GOAL_NOT_FOUND: 'GOAL_NOT_FOUND',
  GOAL_TRACKED: 'GOAL_TRACKED',
  EXPERIMENT_SUMMARIES_ERROR: 'EXPERIMENT_SUMMARIES_ERROR',
  EXPERIMENT_NOT_RUNNING: 'EXPERIMENT_NOT_RUNNING'
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    throwError = _require.throwError;

var abTypes = __webpack_require__(1);

var abAnalytics = function abAnalytics(analytics) {
  if (!analytics) {
    throwError('[abClient] analytics parameter required');
  }

  var trackExperiment = function trackExperiment(options, callback) {
    var experimentData = {
      experiment_name: options.experimentName,
      variant: parseInt(options.variant, 10)
    };

    if (options.experimentNumber !== undefined) {
      experimentData.experiment_number = parseInt(options.experimentNumber, 10);
    }

    analytics.track('track_experiment', experimentData, function (error) {
      if (error) {
        throwError(error);
      }
      if (callback) {
        callback({
          type: abTypes.EXPERIMENT_TRACKED,
          payload: options.experimentName
        });
      }
    });
  };

  var trackGoal = function trackGoal(options, callback) {
    analytics.track('track_goal', { goal_name: options.goalName }, function (error) {
      if (error) {
        throwError(error);
      }
      if (callback) {
        callback({ type: abTypes.GOAL_TRACKED, payload: options.goalName });
      }
    });
  };

  return {
    trackExperiment: trackExperiment,
    trackGoal: trackGoal
  };
};

module.exports = abAnalytics;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    throwError = _require.throwError,
    getExperiment = _require.getExperiment,
    getGoal = _require.getGoal;

var abTypes = __webpack_require__(1);

var OPENTABLE_UNIQUE_VISITOR_ID = 'otuvid';

var abClient = function abClient(abPlatform, abVariantCalculator, abAnalytics, cookies) {
  if (!cookies) {
    throwError('[abClient] cookies parameter required');
  }

  var initialised = false;
  var experimentSummaries = null;
  var init = function init(options, callback) {
    if (initialised) {
      callback({ type: abTypes.CLIENT_INITIALISED });
    } else {
      abPlatform.fetchExperimentSummaries(options, function (message) {
        if (message.type === abTypes.EXPERIMENT_SUMMARIES_ERROR) {
          callback(message);
        } else {
          experimentSummaries = message.payload;
          initialised = true;
          callback({ type: abTypes.CLIENT_INITIALISED });
        }
      });
    }
  };

  var getVariant = function getVariant(options, callback) {
    var experiment = getExperiment(experimentSummaries, options.experimentName);
    if (!experiment) {
      throwError(abTypes.EXPERIMENT_NOT_FOUND + ' ' + options.experimentName);
    }
    experiment.uniqueVisitorId = cookies.get(OPENTABLE_UNIQUE_VISITOR_ID);
    abVariantCalculator.calculateVariant({ experiment: experiment, url: options.url }, function (message) {
      callback(message);
    });
  };

  var trackExperiment = function trackExperiment(options, callback) {
    var experiment = getExperiment(experimentSummaries, options.experimentName);
    if (!experiment) {
      throwError(abTypes.EXPERIMENT_NOT_FOUND + ' ' + options.experimentName);
    } else if (experiment.stage.toUpperCase() !== 'RUNNING') {
      callback({ type: abTypes.EXPERIMENT_NOT_RUNNING });
    } else {
      var copy = Object.assign({}, options);
      copy.experimentNumber = experiment.number;
      abAnalytics.trackExperiment(copy, callback);
    }
  };

  var trackGoal = function trackGoal(options, callback) {
    var goal = getGoal(experimentSummaries, options.goalName);
    if (!goal) {
      throwError(abTypes.GOAL_NOT_FOUND + ' ' + options.goalName);
    }
    abAnalytics.trackGoal(options, callback);
  };

  return {
    init: init,
    getVariant: getVariant,
    messageTypes: abTypes,
    trackExperiment: trackExperiment,
    trackGoal: trackGoal
  };
};

module.exports = abClient;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    throwError = _require.throwError;

var abTypes = __webpack_require__(1);

var abPlatform = function abPlatform($) {
  if (!$) {
    throwError('[abClient] jQuery parameter required');
  }

  var makeData = function makeData(platform, environment, domain) {
    return {
      modifyCounts: {
        experimentModifyCount: -1,
        goalModifyCount: -1
      },
      platform: platform,
      env: environment,
      domain: domain
    };
  };

  var fetchExperimentSummaries = function fetchExperimentSummaries(options, callback) {
    $.ajax({
      url: options.experimentSummariesUrl,
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(makeData(options.platform, options.environment, options.domain)),
      success: function success(data) {
        callback({ type: abTypes.EXPERIMENT_SUMMARIES_FETCHED, payload: data });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        callback({
          type: abTypes.EXPERIMENT_SUMMARIES_ERROR,
          payload: errorThrown
        });
      }
    });
  };

  return {
    fetchExperimentSummaries: fetchExperimentSummaries
  };
};

module.exports = abPlatform;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    throwError = _require.throwError;

var abTypes = __webpack_require__(1);

var abVariantCalculator = function abVariantCalculator($) {
  if (!$) {
    throwError('[abClient] jQuery parameter required');
  }

  var calculateVariant = function calculateVariant(options, callback) {
    $.ajax({
      type: 'GET',
      contentType: 'application/json',
      dataType: 'json',
      url: options.url,
      data: options.experiment,
      headers: { Accept: 'application/vnd.oc.unrendered+json' }, // info: this is used by oc
      success: function success(_ref) {
        var data = _ref.data;

        callback({ type: abTypes.VARIANT_CALCULATED, payload: parseInt(data.variant, 10) });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        throwError(errorThrown);
      }
    });
  };

  return {
    calculateVariant: calculateVariant
  };
};

module.exports = abVariantCalculator;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var abAnalytics = __webpack_require__(2);
var abClient = __webpack_require__(3);
var abPlatform = __webpack_require__(4);
var abVariantCalculator = __webpack_require__(5);

window.OT = window.OT || {};
window.OT.Common = window.OT.Common || {};

var client = abClient(abPlatform(window.$ || window.jQuery), abVariantCalculator(window.$ || window.jQuery), abAnalytics(window.analytics), window.OT.Common.Cookies);

window.OT.Common.abClient = client;

if (window.OT.Events) {
  window.OT.Events.fire('abClient:ready');
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js